export default function () {
  // Show an 'x' in the cart count when in the theme editor and viewing the header section
  document.addEventListener('shopify:section:load', handleSectionLoadSelect);
  document.addEventListener('shopify:section:select', handleSectionLoadSelect);

  function handleSectionLoadSelect(e) {
    if (e.detail.sectionId !== 'INF-Header') {
      return;
    }

    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    if (cartCountElements.length > 0) {
      console.log('cartCountElements--handleSectionLoadSelect', cartCountElements);

      const cartCountText = cartCountElements[0].textContent;
      if (cartCountText !== '0' && cartCountText !== 'x') {
        return;
      }

      cartCountElements.forEach((element) => {
        element.textContent = 'x';
        element.setAttribute('data-cart-count', 'x');
      });
    }
  }

  // Remove 'x' in the cart count when leaving header section
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.detail.sectionId !== 'INF-Header') {
      return;
    }

    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    if (cartCountElements.length > 0) {
      console.log('cartCountElements--deselect', cartCountElements);
      const cartCountText = cartCountElements[0].textContent;
      if (cartCountText !== 'x') {
        return;
      }

      cartCountElements.forEach((element) => {
        element.textContent = '0';
        element.setAttribute('data-cart-count', '0');
      });
    }
  });
}
